import MembershipOpenInvoiceListPagingResultModelBase from '../_generated/modelBases/membership-open-invoice-list-paging-result-model-base';

export default class MembershipOpenInvoiceListPagingResultModel extends MembershipOpenInvoiceListPagingResultModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
